/*
 * Mint marker stroke drawn under one highlighted headline word.
 * Pair with `.home-mark` (home.css). Same path as the hero's stroke.
 */
function MarkerStroke() {
  return (
    <svg viewBox="0 0 200 10" preserveAspectRatio="none" aria-hidden="true">
      <path d="M3 7 C 55 2, 145 2, 197 6" fill="none" stroke="currentColor" strokeWidth="5" strokeLinecap="round" />
    </svg>
  );
}

export default MarkerStroke;
